import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import CommonStyles from "@components/CommonStyles";
import { ITimeTablePeriod } from "@base/modules/appointment/appointment.interface";

interface IProps {
  slots: ITimeTablePeriod[];
  selected?: ITimeTablePeriod;
  isLoading?: boolean;
  /** Clicking the chosen slot again clears it. */
  onChange: (slot?: ITimeTablePeriod) => void;
}

/** The free slots of the chosen doctor and day, `HH:mm` of each start. */
export default function TimeSlotGrid({ slots, selected, isLoading, onChange }: IProps) {
  //! state
  const { t } = useTranslation();

  //! render
  if (isLoading) {
    return <CommonStyles.LoadingUI />;
  }

  if (!slots.length) {
    return (
      <div className="w-full bg-common-background rounded-lg p-3 text-center flex flex-col gap-1">
        <span className="text-common-maintext text-sm font-medium font-['Inter']">{t("booking.noSlotTitle")}</span>
        <span className="text-common-subtext text-xs font-normal font-['Inter']">{t("booking.noSlotDescription")}</span>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 sm:grid-cols-5 xl:grid-cols-6 gap-x-4 gap-y-2 max-h-[270px] overflow-y-auto">
      {slots.map((slot) => {
        const isActive = selected?.id === slot.id;

        return (
          <button
            type="button"
            key={slot.id}
            onClick={() => onChange(isActive ? undefined : slot)}
            className={`border rounded-md text-center py-3 cursor-pointer text-sm ${
              isActive ? "border-common-primary bg-common-primary100 text-common-primary" : "border-common-divider bg-common-white"
            }`}
          >
            {dayjs(slot.period_start_time).format("HH:mm")}
          </button>
        );
      })}
    </div>
  );
}
